'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import { AnimatedButton } from '@/components/ui/animated-button';
import { Panel, PanelContent } from '@/components/ui/panel';
import { useIntentRoutePrefetch } from '@/hooks/use-intent-route-prefetch';
import { Link } from '@/i18n/navigation';
import { cn } from '@/lib/ui/utils';
const HOT_TAKE_FLAME_SRC = '/assets/hot-take-flame.png';
const HOT_TAKE_FLAME_BARS_PX = 96;
const HOT_TAKE_FLAME_STACKED_PX = 48;
export interface SparseCardProps {
  outcomeLayout?: 'bars' | 'stacked';
  surface?: 'card' | 'list';
}
export function SparseCard(t0) {
  const $ = _c(42);
  const {
    outcomeLayout: t1,
    surface: t2
  } = t0;
  const outcomeLayout = t1 === undefined ? "bars" : t1;
  const surface = t2 === undefined ? "card" : t2;
  const t = useTranslations("markets");
  const intent = useIntentRoutePrefetch("/proposals");
  const stacked = outcomeLayout === "stacked";
  const listRow = stacked && surface === "list";
  const flameSizePx = stacked ? HOT_TAKE_FLAME_STACKED_PX : HOT_TAKE_FLAME_BARS_PX;
  let t3;
  if ($[0] !== t) {
    t3 = t("sparse.cta");
    $[0] = t;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = !stacked && "md:aspect-[4/3]";
  let t5;
  if ($[2] !== t4) {
    t5 = cn("block h-full min-h-0 rounded-card focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-primary", t4);
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const t6 = listRow ? "none" : "solid";
  const t7 = !listRow && "transition-[box-shadow,border-color] duration-fast ease-default motion-reduce:transition-none hover:border-border-primary hover:shadow-elevation-card";
  const t8 = stacked && !listRow && "p-4";
  let t9;
  if ($[4] !== t7 || $[5] !== t8) {
    t9 = cn("h-full min-h-0 cursor-pointer overflow-hidden", t7, t8);
    $[4] = t7;
    $[5] = t8;
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  const t10 = stacked ? "gap-2 p-0" : "gap-4 p-6";
  let t11;
  if ($[7] !== t10) {
    t11 = cn("flex h-full min-h-0 flex-col items-center justify-center text-center", t10);
    $[7] = t10;
    $[8] = t11;
  } else {
    t11 = $[8];
  }
  const t12 = stacked ? "size-12" : "size-24";
  let t13;
  if ($[9] !== t12) {
    t13 = cn("relative shrink-0 overflow-hidden", t12);
    $[9] = t12;
    $[10] = t13;
  } else {
    t13 = $[10];
  }
  let t14;
  if ($[11] !== flameSizePx) {
    t14 = <Image src={HOT_TAKE_FLAME_SRC} alt="" width={flameSizePx} height={flameSizePx} className="size-full object-contain" />;
    $[11] = flameSizePx;
    $[12] = t14;
  } else {
    t14 = $[12];
  }
  let t15;
  if ($[13] !== t13 || $[14] !== t14) {
    t15 = <div aria-hidden="true" className={t13}>{t14}</div>;
    $[13] = t13;
    $[14] = t14;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  const t16 = stacked ? "text-heading-sm font-semibold" : "text-heading-lg";
  let t17;
  if ($[16] !== t) {
    t17 = t("sparse.title");
    $[16] = t;
    $[17] = t17;
  } else {
    t17 = $[17];
  }
  let t18;
  if ($[18] !== t16 || $[19] !== t17) {
    t18 = <p className={t16}>{t17}</p>;
    $[18] = t16;
    $[19] = t17;
    $[20] = t18;
  } else {
    t18 = $[20];
  }
  let t19;
  if ($[21] !== t) {
    t19 = t("sparse.cta");
    $[21] = t;
    $[22] = t19;
  } else {
    t19 = $[22];
  }
  let t20;
  if ($[23] !== t19) {
    t20 = <AnimatedButton variant="secondary" size="sm" asChild={true}><span>{t19}</span></AnimatedButton>;
    $[23] = t19;
    $[24] = t20;
  } else {
    t20 = $[24];
  }
  let t21;
  if ($[25] !== t11 || $[26] !== t15 || $[27] !== t18 || $[28] !== t20) {
    t21 = <PanelContent className={t11}>{t15}{t18}{t20}</PanelContent>;
    $[25] = t11;
    $[26] = t15;
    $[27] = t18;
    $[28] = t20;
    $[29] = t21;
  } else {
    t21 = $[29];
  }
  let t22;
  if ($[30] !== listRow || $[31] !== t21 || $[32] !== t6 || $[33] !== t9) {
    t22 = <Panel surface={t6} inheritBackground={listRow} elevation="flat" className={t9}>{t21}</Panel>;
    $[30] = listRow;
    $[31] = t21;
    $[32] = t6;
    $[33] = t9;
    $[34] = t22;
  } else {
    t22 = $[34];
  }
  let t23;
  if ($[35] !== intent || $[36] !== t22 || $[37] !== t3 || $[38] !== t5) {
    t23 = <Link href="/proposals" prefetch={false} {...intent} aria-label={t3} className={t5}>{t22}</Link>;
    $[35] = intent;
    $[36] = t22;
    $[37] = t3;
    $[38] = t5;
    $[39] = t23;
  } else {
    t23 = $[39];
  }
  const card = t23;
  if (listRow) {
    let t24;
    if ($[40] !== card) {
      t24 = <div className="py-6">{card}</div>;
      $[40] = card;
      $[41] = t24;
    } else {
      t24 = $[41];
    }
    return t24;
  }
  return card;
}